import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgReports = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 14,
	height: 14,
	viewBox: "0 0 14 14",
	fill: "none",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M1.1665 4.08366C1.1665 2.47283 2.47234 1.16699 4.08317 1.16699H9.9165C11.5273 1.16699 12.8332 2.47283 12.8332 4.08366V9.91699C12.8332 11.5278 11.5273 12.8337 9.9165 12.8337H4.08317C2.47234 12.8337 1.1665 11.5278 1.1665 9.91699V4.08366ZM4.08317 2.33366C3.11667 2.33366 2.33317 3.11716 2.33317 4.08366V9.91699C2.33317 10.8835 3.11667 11.667 4.08317 11.667H9.9165C10.883 11.667 11.6665 10.8835 11.6665 9.91699V4.08366C11.6665 3.11716 10.883 2.33366 9.9165 2.33366H4.08317Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.33333 7.58398C9.65551 7.58398 9.91667 7.84514 9.91667 8.16732V9.33398C9.91667 9.65616 9.65551 9.91732 9.33333 9.91732C9.01116 9.91732 8.75 9.65616 8.75 9.33398V8.16732C8.75 7.84514 9.01116 7.58398 9.33333 7.58398Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M4.66634 4.08398C4.9885 4.08398 5.24967 4.34515 5.24967 4.66732V9.33398C5.24967 9.65616 4.9885 9.91732 4.66634 9.91732C4.34417 9.91732 4.08301 9.65616 4.08301 9.33398V4.66732C4.08301 4.34515 4.34418 4.08398 4.66634 4.08398Z",
			fill: "currentColor"
		}),
		/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M6.99984 5.83398C7.32201 5.83398 7.58317 6.09514 7.58317 6.41732V9.33398C7.58317 9.65616 7.32201 9.91732 6.99984 9.91732C6.67766 9.91732 6.4165 9.65616 6.4165 9.33398V6.41732C6.4165 6.09514 6.67766 5.83398 6.99984 5.83398Z",
			fill: "currentColor"
		})
	]
});
const ForwardRef = forwardRef(SvgReports);
export default ForwardRef;
